import { CommonUtilities } from '../../commonUtils';
import React, { Suspense, useEffect, useState } from 'react';
import DirectoriesIndex from '../directories/directoriesIndex';
import AssetCompareIndex from '../MetaData/AssetPortal/AssetCompareIndex';
import TipaltiPayment from '../../components/Payment/Tipalti/AuthInitialisation';
import DataLoader from 'components/DataLoading/DataLoader';
import MetaDataMainUI from 'components/MetaData/MetaDataMainUI';
import Reports from 'components/Reports/Reports';

export default function Dashboard(params: any) {

    var userAccessContents = JSON.parse(window.sessionStorage.getItem('loggedUserRight') as string);
    let [portalName, setPortalName] = useState("")
    const [portalNamet, setPortalNamet] = useState(portalName);
    const allowedEmails = [
        'simonp@kartelsolutions.com',
        'ridhimaj@kartelsolutions.com',
        'prithivi@kartelsolutions.com',
        'mirza@kartelsolutions.com',
        'simon.p@korrectsw.com',
        'Rehaan@gmail.com'
    ];
    const selectSubEntity = (SubEntity: any) => {

        console.log(SubEntity)
        console.log(CommonUtilities.iconUrlAssignment(SubEntity.subEntity))

        if (SubEntity && SubEntity.subEntity == "Production") {
            window.location.href = '../Production';
        }

        if (SubEntity.subEntityType === 0 && !SubEntity.subEntity.includes("Reports")) {
            console.log(SubEntity)
            if (CommonUtilities.iconUrlAssignment(SubEntity.subEntity)) {
                const iconUrl = CommonUtilities?.iconUrlAssignment(SubEntity.subEntity) || '';
                window.location.href = iconUrl;
            }
        }

        if (SubEntity.subEntity.includes("Reports")) {
            window.location.href = 'Reports';
        }

        if (SubEntity.subEntityType === 1 || SubEntity.subEntity.includes("Reports")) {
            console.log(SubEntity)
            const noSpaces = SubEntity.subEntity.replace(/\s+/g, "");
            console.log(noSpaces)
            console.log(SubEntity.subEntity);
            setPortalName(noSpaces);
        }

    }

    const SubEntities = (SubEntities: any) => {

        return (
            <div className='ws-12 mbl '>
                {SubEntities.subEntities.map(function (subEntity: any, index: number) {

                    if (subEntity.subEntityType === 1) {
                        return (
                            <>
                                <div className="box-primary text-center iconLogo pull-left">
                                    <a href={'/' + subEntity.subEntity.replace(/\s+/g, "")}>
                                        <div className="ws-12">
                                            <i className={"box icon-" + subEntity.subEntityCode}></i>
                                            <span className="m0 pts">{subEntity.subEntity} </span>
                                        </div>
                                    </a>
                                </div>
                            </>
                        );
                    }
                })}
            </div>
        )
    }

    useEffect(() => {
        if (window.location.pathname.includes("directories") && portalName !== 'Directories') {
            portalName = "Directories";
            setPortalName(portalName)
            localStorage.setItem('panelName', "OpenDirectories");
        }
        else if (window.location.pathname.includes("tipalti") && portalName !== 'tipalti' && localStorage.getItem('panelName') !== "Opentipalti") {
            portalName = "tipalti";
            setPortalName(portalName)
            setPortalNamet(portalName)
            localStorage.setItem('panelName', "Opentipalti");
        } else if (window.location.pathname.includes("Reports")) {
            portalName = "Reports";
            setPortalName(portalName)
            localStorage.setItem('panelName', "OpenDirectories");
        } else {
            setPortalName('')
            localStorage.setItem('panelName', "");
        }

    }, [window.location.pathname]);

    return (

        <div className='ws-12 mtl'>

            {userAccessContents.userEntityRight?.map((entrieObj: any) => {
                return (
                    <div className='box mb'>
                        <div className='box-header bg-level0'> {entrieObj.entityName == 252 ? 'Production' : entrieObj.entityName}  </div>

                        <div className='box-content'>
                            {entrieObj.subEntities.map((SubentrieObj: any) => {
                                return (
                                    <div className="box-primary text-center iconLogo pull-left">
                                        {<a onClick={() => selectSubEntity(SubentrieObj)}>
                                            <div className="ws-12">
                                                <i className={'box icon-' + SubentrieObj.subEntityCode} />
                                                <span className="m0 pts" >{SubentrieObj.subEntity}</span>
                                            </div>
                                        </a>}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                )

            })}

            {(() => {

                if (portalName !== '' && portalName === "Directories") {
                    return <DirectoriesIndex pathname={portalName} />
                }

                if (portalName !== '' && portalName === "castManager") {
                    return <MetaDataMainUI pathname={portalName} />
                }

                if (portalName !== '' && portalName === "Uploader") {
                    return <DataLoader pathname={portalName} />
                }

                if (portalName !== '' && (portalName === "Asset Compare" || portalName === 'AssetCompare')) {
                    return <AssetCompareIndex pathname={'/assetCompare/'} />
                }

                if (portalName !== '' && portalName === "tipalti") {
                    return <TipaltiPayment pathname={'tipalti'} />
                }

                if (portalName !== '' && portalName === "Reports") {
                    return <Reports pathname={'/Reports'} />
                }

            })()}

            {<div className={(allowedEmails.includes(JSON.parse(window.sessionStorage.getItem('loggedUserRight') as string).email)) ? 'box mb' : 'hide'}>
                <div className='box-header bg-level0'>
                    Migration
                </div>
                <div className='box-content'>
                    <SubEntities subEntities={[
                        { subEntityID: 32, subEntityCode: "download", subEntity: "Uploader", subEntityRef: 111, entityType: 1, isActive: 1, subEntityType: 1 },
                        { subEntityID: 32, subEntityCode: "TrackSplit", subEntity: "TrackSplit", subEntityRef: 111, entityType: 128, isActive: 1, subEntityType: 1 },
                        { subEntityID: 32, subEntityCode: "Grid_Contracts", subEntity: "Contracts", subEntityRef: 111, entityType: 128, isActive: 1, subEntityType: 1 },
                        { subEntityID: 32, subEntityCode: "Grid_ProjectContract", subEntity: "Projects", subEntityRef: 111, entityType: 128, isActive: 1, subEntityType: 1 },
                        { subEntityID: 32, subEntityCode: "Grid_Contacts", subEntity: "Contacts", subEntityRef: 111, entityType: 1, isActive: 1, subEntityType: 1 },
                        { subEntityID: 32, subEntityCode: "Grid_Approval", subEntity: "UI Setting", subEntityRef: 111, entityType: 1, isActive: 1, subEntityType: 1 },
                        { subEntityID: 32, subEntityCode: "generate-report", subEntity: "Create Templates", subEntityRef: 111, entityType: 1, isActive: 1, subEntityType: 1 },
                        { subEntityID: 32, subEntityCode: "music", subEntity: "Production", subEntityRef: 111, entityType: 1, isActive: 1, subEntityType: 1 },
                        { subEntityID: 32, subEntityCode: "Grid_Reporting", subEntity: "Reports", subEntityRef: 111, entityType: 1, isActive: 1, subEntityType: 1 },
                        { subEntityID: 32, subEntityCode: "Mechanical", subEntity: "Mechanicals", subEntityRef: 111, entityType: 1, isActive: 1, subEntityType: 1 },
                        { subEntityID: 32, subEntityCode: "SuggestedPayments", subEntity: "Payments", subEntityRef: 111, entityType: 1, isActive: 1, subEntityType: 1 },
                        { subEntityID: 32, subEntityCode: "Digital_Transaction", subEntity: "Transaction", subEntityRef: 111, entityType: 1, isActive: 1, subEntityType: 1 }
                    ]} />


                </div>
            </div>}

        </div>
    );
}
